import { PaymentReceiptPage } from '@/features/payment-receipt';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Página pública para onde a Autra devolve o segurado depois do pagamento. Fica
 * fora do `_app` (que exige login) e do `_auth` (que manda quem está logado ao
 * dashboard): o segurado não tem conta no Portal.
 */
export const Route = createFileRoute('/payment/$token')({
  component: PaymentReceiptRoute,
});

function PaymentReceiptRoute() {
  const { token } = Route.useParams();
  return <PaymentReceiptPage token={token} />;
}
